// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2fxUz","header":"ReportDetails_header__jPyzk","title":"ReportDetails_title__pzNgR","left":"ReportDetails_left__15pYG"};